// Servicio para manejar la autenticación JWT
export default function AuthService() {
  // Constantes para los tokens
  const ACCESS_TOKEN_KEY = 'access_token';
  const REFRESH_TOKEN_KEY = 'refresh_token';
  const USER_DATA_KEY = 'user_data';

  return {
    setAuthTokens,
    getAccessToken,
    getRefreshToken,
    clearTokens,
    isAuthenticated,
    setUserData,
    getUserData,
    clearUserData,
  };

  /**
   * Almacena los tokens JWT en localStorage
   * @param {string} accessToken - Token de acceso JWT
   * @param {string} refreshToken - Token de refresco JWT
   */
  function setAuthTokens(accessToken, refreshToken) {
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  }

  /**
   * Obtiene el token de acceso del almacenamiento local
   * @returns {string|null} El token de acceso o null si no existe
   */
  function getAccessToken() {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  }

  /**
   * Obtiene el token de refresco del almacenamiento local
   * @returns {string|null} El token de refresco o null si no existe
   */
  function getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  }

  /**
   * Elimina los tokens del almacenamiento local
   */
  function clearTokens() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(USER_DATA_KEY);
  }

  /**
   * Verifica si el usuario está autenticado (tiene un token de acceso)
   * @returns {boolean} true si está autenticado, false si no
   */
  function isAuthenticated() {
    return !!getAccessToken();
  }

  /**
   * Almacena los datos del usuario en localStorage
   * @param {Object} userData - Datos del usuario a almacenar
   */
  function setUserData(userData) {
    localStorage.setItem(USER_DATA_KEY, JSON.stringify(userData));
  }

  /**
   * Obtiene los datos del usuario del almacenamiento local
   * @returns {Object|null} Los datos del usuario o null si no existen
   */
  function getUserData() {
    const userData = localStorage.getItem(USER_DATA_KEY);
    return userData ? JSON.parse(userData) : null;
  }

  /**
   * Elimina los datos del usuario del almacenamiento local
   */
  function clearUserData() {
    localStorage.removeItem(USER_DATA_KEY);
  }
} 